import Layout from '../../layout/detail.vue';
const articleRouter = {
    path: '/',
    component: Layout,
    redirect: '/',
    name: 'drcnetArticle',
    meta: {
        title: '1',
        sort: 4,
    },
    children: [{
            path: '/',
            component: () =>
                import ('@/pages/retrieveProjectSritNew/views/homePage/home.vue'),
            name: 'home',
        },
        {
            path: '/tagPush',
            component: () =>
                import ('@/pages/retrieveProjectSritNew/views/viewPage/tagPush.vue'),
            name: 'tagPush',
        },
        // {
        //     path: '/simpleSearch',
        //     component: () =>
        //         import ('@/pages/retrieveProjectSrit/views/simpleSearchPage/simpleSearch.vue'),
        //     name: 'simpleSearch',
        // },
        // 高级搜索
        {
            path: '/advancedSearch',
            component: () =>
                import ('@/pages/retrieveProjectSritNew/views/advancedSearch/advancedSearch.vue'),
            name: 'advancedSearch',
        },
        // 个人搜索页面
        {
            path: '/personalSearch',
            component: () =>
                import ('@/pages/retrieveProjectSritNew/views/viewPage/personalSearch.vue'),
            name: 'personalSearch',
        },
        // 项目搜索页面
        {
            path: '/rangeSearch',
            component: () =>
                import ('@/pages/retrieveProjectSritNew/views/rangeSearch/index.vue'),
            name: 'rangeSearch',
        },
        // {
        //     path: '/rangeSearchCase',
        //     component: () =>
        //         import ('@/pages/retrieveProjectSrit/views/rangeSearch/caseGit.vue'),
        //     name: 'rangeSearchCase',
        // },

    ],
};

export default articleRouter;